import { Fragment } from "react";
import { useDispatch } from "react-redux";
import { MenuItem as MuiMenuItem } from "@mui/material";
import styled from "styled-components";

import { signOutMember } from "../../../../redux/slices/memberSlice";

const MenuItem = styled(MuiMenuItem)`
  min-width: 200px;
`;

export default function DropDownMenu() {
  const dispatch = useDispatch();

  return (
    <Fragment>
      <MenuItem onClick={() => dispatch(signOutMember())}>Sign Out</MenuItem>
    </Fragment>
  );
}
